import { render, staticRenderFns } from "./Structure.vue?vue&type=template&id=2ad4852e&"
import script from "./Structure.vue?vue&type=script&lang=js&"
export * from "./Structure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports